import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { get_users_by_product } from "@src/redux/action/access_control/UsersAction";
import { useDispatch, useSelector } from "react-redux";
import { CustomPagination } from "@store/action/GlobalAction";
import AvatarPng from "@components/avatar/avatr.png";
import "@styles/sass/5-pages/team.scss";

const Team = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  useEffect(() => {
    dispatch(
      get_users_by_product({
        page: currentPage,
        per_page: rowsPerPage,
      })
    );
  }, [currentPage]);
  const user_by_product = useSelector(
    (state) => state.UserReducers.users_by_product_id
  );
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("Team")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t("Team")}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      {user_by_product?.data && user_by_product?.data.length ? (
        <>
          <section className="team-part">
            <div className="container__video">
              <div className="row">
                {user_by_product?.data?.map((user, i) => {
                  const role = user?.roles?.length ? user.roles[0].name : "";
                  return (
                    <div
                      key={`users_by_producr${i}`}
                      className="col-6 col-sm-6 col-md-4 col-lg-3"
                    >
                      <div className="team-card team-gape">
                        <div className="team-img">
                          <img
                            width="500px"
                            height="250px"
                            style={{ objectFit: "contain" }}
                            src={user.avatar ? user.avatar : AvatarPng}
                            alt={user?.user_name}
                          />
                          {/* <div className="team-overlay">
                        <ul className="team-icon">
                          <li>
                            <a className="icon icon-inline" href="#">
                              <i className="fa fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a className="icon icon-inline" href="#">
                              <i className="fa fa-twitter"></i>
                            </a>
                          </li>
                          <li>
                            <a className="icon icon-inline" href="#">
                              <i className="fa fa-linkedin"></i>
                            </a>
                          </li>
                        </ul>
                      </div> */}
                        </div>
                        <div className="team-meta">
                          <h4>{`${user?.first_name} ${user.last_name}`} </h4>
                          <p>{role}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
          <div className="d-flex justify-content-center">
            {CustomPagination(
              user_by_product.total,
              rowsPerPage,
              handlePageChange
            )}
          </div>
        </>
      ) : (
        <section className="team-part">
          <div className="container__video">
            <div className="row">
              <h6
                style={{
                  margin: "150px 0",
                }}
                className="text-black text-center"
              >
                {t("No users Found")}
              </h6>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Team;
